import Home from "./components/Home";
import FocusWindow from "./components/FocusWindow";
import SearchPopup from "./components/ui/SearchPopup";
import FocusWindowRealTimeDetection from "./components/FocusWindowRealTimeDetection";
import EventDashboard from "./components/EventDashboard";
import ConciergeDashboard from "./components/ConciergeDashboard";
import RosterDashboard from "./components/RosterDashboard";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ActiveCameras from "./components/ActiveCameras";
import ThresholdConfigWindow from "./components/ThresholdConfigWindow";
import ThresholdViewWindow from "./components/ThresholdViewWindow";
import { PersonIdentificationProvider } from "./contexts/PersonIdentificationContext";
import { DemoModeProvider } from "./contexts/DemoModeContext";
import { useEffect, useState } from 'react';
import { getCurrentUser, signInWithRedirect } from 'aws-amplify/auth';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getCurrentUser()
      .then(() => setIsAuthenticated(true))
      .catch(() => signInWithRedirect())
      .finally(() => setIsLoading(false));
  }, []);

  if (isLoading) return <div>Loading...</div>;
  if (!isAuthenticated) return null;

  return (
    <BrowserRouter>
      <DemoModeProvider>
        <PersonIdentificationProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/focus" element={<FocusWindow />} />
            <Route path="/search-popup" element={<SearchPopup />} />
            <Route path="/focus-realtime" element={<FocusWindowRealTimeDetection />} />
            <Route path="/events" element={<EventDashboard />} />
            <Route path="/concierge" element={<ConciergeDashboard />} />
            <Route path="/cameras" element={<ActiveCameras />} />
            <Route path="/roster" element={<RosterDashboard key="roster-key" />} />
            <Route path="/threshold-config" element={<ThresholdConfigWindow />} />
            <Route path="/threshold-view" element={<ThresholdViewWindow />} />
          </Routes>
        </PersonIdentificationProvider>
      </DemoModeProvider>
    </BrowserRouter>
  );
}

export default App;